import React, {useState} from "react";



const JobDetails = ({Designation,description1,description2, description3, description4 }) =>{
    const [show, setshow] = useState(false);
    return(
        <div className="careerjoblist">
            <h2 onClick={()=>setshow(!show)}><span>{show? "-":"+"}</span> {Designation}</h2>
             {show && <p>Skill Requirement:<ul><li>{description1}</li><li>{description2}</li><li>{description3}</li><li>{description4}</li></ul></p>}
        </div>                      
                          
    )
}

export default JobDetails